import React, { useState } from 'react';
import { isNil } from 'ramda';
import { UserResource } from '~~apis/resource';
import Input from '~~elements/Input';
import Button from '~~elements/Button';
import Checkbox from '~~elements/Checkbox';
import { useQuery } from '~~utils/CommonUtils';
import IconEmail from './assets/IconEmail.svg';
import IconPassword from './assets/IconPassword.svg';
import IconUser from './assets/IconUser.svg';
import IconPasswordConfirm from './assets/IconPasswordConfirm.svg';
import { StyledForm } from './Styles';
import { STATUS } from './LoginConsts';
import { isEmbeddedWebview } from './Const';

const SignUpForm = () => {
  const query = useQuery();
  const doneURL = query.get('done_url');
  const [data, setData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    passwordConfirm: '',
    subscribe: true,
  });
  const [errorMsg, setErrorMsg] = useState(null);
  const [apiStatus, setApiStatus] = useState(null);

  function handleSubmit(e) {
    e.preventDefault();

    const sendRegisterRequest = (recaptchaToken) => {
      UserResource.register({
        first_name: data.firstName,
        last_name: data.lastName,
        email: data.email,
        password: data.password,
        subscribe: data.subscribe,
        recaptcha_token: recaptchaToken,
      })
        .then(() => {
          setApiStatus('SUCCESS');
        })
        .catch((error) => {
          return handleError(error.message);
        });
    };

    setApiStatus('LOADING');

    if (data.password !== data.passwordConfirm) {
      return handleError('PASSWORD_CONFIRM_NOT_EQUAL');
    }

    const recaptchaKey = document.querySelector('meta[name="google-recaptcha-score-key"]').getAttribute('content');
    if (recaptchaKey && recaptchaKey.slice(0, 2) !== '{{') {
      window.grecaptcha.enterprise.ready(() => {
        window.grecaptcha.enterprise.execute(recaptchaKey, { action: 'SIGNUP' }).then((token) => {
          sendRegisterRequest(token);
        });
      });
    } else {
      sendRegisterRequest('');
    }
  }

  function handleLoginFB(e) {
    e.preventDefault();
    const appendQuery = !doneURL ? '' : `?done_url=${doneURL}`;

    const targetURL = `${process.env.REACT_APP_BACKEND_URL}/auth/facebook${appendQuery}`;
    window.location.href = targetURL;
    window.location.replace(targetURL);
  }

  function handleLoginGoogle(e) {
    e.preventDefault();
    const appendQuery = !doneURL ? '' : `?done_url=${doneURL}`;

    const targetURL = `${process.env.REACT_APP_BACKEND_URL}/auth/google${appendQuery}`;
    window.location.href = targetURL;
    window.location.replace(targetURL);
  }

  function handleInputOnchange(e) {
    if (errorMsg) {
      setErrorMsg(null);
    }

    const key = e.target.name;
    const value = e.target.value;
    setData({
      ...data,
      [key]: value,
    });
  }

  function handleCheckBox(name) {
    return function (e) {
      e.preventDefault();
      setData({
        ...data,
        [name]: !data[name],
      });
    };
  }

  function handleKeyPress(e) {
    if ('Enter' !== e.key) {
      return;
    }

    e.preventDefault();
    if (handleCheckDisabled()) {
      return;
    }

    return handleSubmit(e);
  }

  function handleError(errorCode) {
    const status = 'ERROR';
    setApiStatus(status);

    let errorMessage = '發生錯誤，請稍後再試，或與聯絡我們。';
    switch (errorCode) {
      case 'PASSWORD_CONFIRM_NOT_EQUAL':
        errorMessage = '確認密碼與密碼不相符';
        break;
      case 'INVALID_FORMAT':
        errorMessage = '格式錯誤';
        break;
      case 'INVALID_NAME_FORMAT':
        errorMessage = '姓名欄位不得為空';
        break;
      case 'INVALID_EMAIL_FORMAT':
        errorMessage = '信箱格式錯誤';
        break;
      case 'INVALID_PASSWORD_FORMAT':
        errorMessage = '密碼需超過五碼並包含至少一個英文及一個數字';
        break;
      case 'INVALID_EMAIL_NOT_EXIST':
        errorMessage = '信箱不存在';
        break;
      case 'EMAIL_DUPLICATE':
        errorMessage = '此信箱已被使用';
        break;
      case 'INVALID_RECAPTCHA_SCORE_RESULT':
        errorMessage = '註冊驗證失敗！請關閉可能影響網站之套件或更換瀏覽器後再試一次。如仍無法成功請與我們聯絡。';
        break;
      default:
        break;
    }

    setErrorMsg(errorMessage);
  }

  function handleCheckDisabled() {
    const isAnyEmpty = Object.keys(data).some((item) => data[item] === '' || isNil(data[item]));
    const result = isAnyEmpty || apiStatus === 'LOADING';
    return result;
  }

  if (apiStatus === 'SUCCESS') {
    return (
      <StyledForm status={STATUS.SIGN_UP}>
        <div className="bottom-box">
          <div className="success-msg">註冊成功！請檢查註冊信箱進行驗證</div>
        </div>
      </StyledForm>
    );
  }

  return (
    <StyledForm onSubmit={(e) => handleSubmit(e)} autoComplete="off" status={STATUS.SIGN_UP}>
      <div className="upper-box">
        社群註冊
        <div className="connection-btns-box">
          <Button boxShadow onClick={handleLoginFB}>
            {' '}
            Facebook{' '}
          </Button>
          {!isEmbeddedWebview() && (
            <Button boxShadow onClick={handleLoginGoogle}>
              {' '}
              Google{' '}
            </Button>
          )}
        </div>
      </div>
      <div className="bottom-box">
        {/* 姓名 */}
        <div className="input-field --multi-input">
          <img src={IconUser} alt="UserName" />
          <div className="input-box">
            <Input
              width="100%"
              placeholder="名"
              name="firstName"
              onChange={handleInputOnchange}
              onKeyPress={handleKeyPress}
              value={data.firstName}
            />
            <Input
              width="100%"
              placeholder="姓"
              name="lastName"
              onChange={handleInputOnchange}
              onKeyPress={handleKeyPress}
              value={data.lastName}
            />
          </div>
        </div>
        {/* 信箱 */}
        <div className="input-field">
          <img src={IconEmail} alt="Email" />
          <Input
            placeholder="信箱"
            name="email"
            type="email"
            onChange={handleInputOnchange}
            onKeyPress={handleKeyPress}
            value={data.email}
          />
        </div>
        {/* 密碼 */}
        <div className="input-field">
          {/* <Icon icon={IconName.IconPassword} /> */}
          <img src={IconPassword} alt="Password" />
          <Input
            placeholder="密碼"
            name="password"
            type="password"
            onChange={handleInputOnchange}
            onKeyPress={handleKeyPress}
            value={data.password}
          />
        </div>
        {/* 確認密碼 */}
        <div className="input-field">
          <img src={IconPasswordConfirm} alt="PasswordConfirm" />
          <Input
            placeholder="確認密碼"
            name="passwordConfirm"
            type="password"
            onChange={handleInputOnchange}
            onKeyPress={handleKeyPress}
            value={data.passwordConfirm}
          />
        </div>
        <div className="input-field">
          <Checkbox checked={data.subscribe} onClick={handleCheckBox('subscribe')} />
          <label className="checkbox-label">我願意透過信箱接受最新消息與優惠通知</label>
        </div>
        <div className="error-msg">{errorMsg && errorMsg}</div>
        <Button boxShadow round width="50%" type="submit" disabled={handleCheckDisabled()}>
          註冊
        </Button>
      </div>
    </StyledForm>
  );
};

export default SignUpForm;
